 $(window).on('scroll', function() {
      $.fn.isInViewport = function() {
          var elementTop = $(this).offset().top;
          var elementBottom = elementTop + $(this).outerHeight();

          var viewportTop = $(window).scrollTop();
          var viewportBottom = viewportTop + $(window).height();

          return elementBottom > viewportTop && elementTop < viewportBottom;
      };

      $(window).on('resize scroll', function() {
          if ($('.shopify-section.shopify-section-group-footer-group').isInViewport()) {
               $('body').addClass("footer-stable");
          } else {
             
            $('body').removeClass("footer-stable");
          }
      });
  });
$(window).on('load', function() {
    AOS.refresh();
});
window.onscroll = function() {
    AOS.refresh();
};



var isInViewport = function(elem) {
  var distance = elem.getBoundingClientRect();
  return (
    distance.top >= 0 &&
    distance.left >= 0 &&
    distance.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    distance.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};
// read the link on how above code works

var findMe = document.querySelectorAll('div#shopify-section-sections--15840723894406__footer');

window.addEventListener('scroll', function(event) {
// add event on scroll
findMe.forEach(element => {
    if (isInViewport(element)) {
      element.classList.add("draw");
       $('body').addClass("footer-stable")
    }
});
}, false);



$(document).ready(function(){




  
  $('.header__inline-menu .list-menu.list-menu--inline a#HeaderMenu-product-care').click(function(e) {
    e.preventDefault();
    window.location.href= "https://honeylux.co/pages/about-us#ProductCare";
  });
  // ----------slide down in pdp page----------
  $('.main-tab-data .description-section.active .going-product-care').click(function(e) {
     e.preventDefault();
    $('html, body').animate({
      scrollTop: $(".product-care2 #ProductCare").offset().top-50
    }, 5000)
  });
  // ---------header menu js----------
  $('body').on('click', function() {
    $(this).children('.section-header').children('sticky-header.header-wrapper').find('.header__menu-item.list-menu__item.link').each(function(){
        var da = $(this).attr('aria-expanded');
        if(da =='true'){
            $('body').addClass('menu-open');
            return false;
        }
        else {
          $('body').removeClass('menu-open');  
        }
    });
  });
// --------------------footer mobile menu -----------------
  if ($(window).width() < 767) {
   $('.footer__content-top.container h2.footer-block__heading.inline-richtext').on('click', function() {
    $(this).parent('.footer-block.grid__item.footer-block--menu ').toggleClass("open-footer");
    });
  };
// -------------------cstm featured collection------------/
$('.cstm-featured-coll-slide .coll-featured').slick({
   infinite: true,
   prevArrow:'<button class="prev_arrow"><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 6H1" stroke="black" stroke-miterlimit="10"/><path d="M6 11L1 6L6 1" stroke="black" stroke-miterlimit="10"/></svg></button>',
   nextArrow:'<button class="next_arrow"><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6H20" stroke="black" stroke-miterlimit="10"/><path d="M15 11L20 6L15 1" stroke="black" stroke-miterlimit="10"/></svg></button>',
   slidesToShow: 4,
   slidesToScroll: 1,
   arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
// -------testimonial product slider-----------

$('.product-slider .product-carousel').slick({
   infinite: true,
   prevArrow:'<button class="prev_arrow"><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 6H1" stroke="black" stroke-miterlimit="10"/><path d="M6 11L1 6L6 1" stroke="black" stroke-miterlimit="10"/></svg></button>',
   nextArrow :'<button class="next_arrow"><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6H20" stroke="black" stroke-miterlimit="10"/><path d="M15 11L20 6L15 1" stroke="black" stroke-miterlimit="10"/></svg></button>',
   slidesToShow: 3,
   slidesToScroll: 1,
   arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 1500,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        speed: 1500,
        autoplaySpeed: 1500,
      }
    }
  ]
});
  // ----------------- popup video section --------------     
$('.product-grids-items .main-product-card.video_popup_wrapper' ).on( "click", function() {
  var id_attr = $(this).attr('data-id');
  var images1 = $('#img-'+id_attr).html();
  $('#show_img2').html(images1);
  $("body").addClass('active');
  $(".custom-model-main").addClass('model-open');
  $("#show_img2 .custom_inner_wrapper .popup_video_inner video").trigger("play");
});
  $(".close-btn.data.close-btn").click(function(){
    $(".custom-model-main").removeClass('model-open');
    $("body").removeClass('active');
    $("#show_img2 .custom_inner_wrapper .popup_video_inner video").trigger("pause");
    $(".custom_inner_wrapper .popup_video_inner video").get(0).currentTime = 0;
  });
  // ------------end-------------
  $('nav.header__inline-menu ul.list-unstyled li').hover(function() {
    var img= $(this).attr("data_img");
    img.src = img;
    $('<img />', {
    src: img,
      }).appendTo( $(this).parent().parent().siblings(".rep-img").empty())
    });
  $('.mega-menu__list .mega-menu__link.mega-menu__link--level-2').hover(function() {
    var img= $(this).attr("data_img");
    img.src = img;
    $('<img />', {
    src: img,
      }).appendTo( $(this).parent().siblings(".rep-img").empty())
    });
  // -----------varient color -----------
  $('.input-var-color').on('click', function() {
    var wpurl = $(this).attr("data-url");
    $(this).parent().siblings(".pdp-main-url").attr('href', wpurl);
    $(this).parent().parent().siblings(".pdp-main-url").attr('href', wpurl);
    var wprice = $(this).attr("data-price");
    $(this).parent().siblings(".pdp-main-title").find('.price-pdp').text(wprice);
    var wsrc = $(this).attr("data-img");
    $(this).parent().parent().siblings(".pdp-main-url").find('.img-pdp-wrapper').attr('src', wsrc);
    var varient_id = $(this).attr("varient-id");
    $(this).parent().siblings("div").find('.product-variant-id').attr('value',varient_id);
  });
   
// ----------contact form popup-------------
  $('footer.footer .footer-block--menu a.contact.link.link--text.list-menu__item.list-menu__item--link').on('click', function(e) {
    e.preventDefault();
    $('body').addClass('get-in-touch-popup');
    $('.contect-form-popup').addClass('get-in-touch-active');
    $('.contect-form-popup.get-in-touch-active .close-icon').on('click', function() {
      $('body').removeClass('get-in-touch-popup');
      $('.contect-form-popup').removeClass('get-in-touch-active');
    });
  });
  // -----------custom faq's ------------
  $(".accordion_tab .blinking-icons-wrapper .heading-accodion").on("click", function() {
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".accordion_tab .blinking-icons-wrapper .content-accodion").slideUp(500);
      } else
    {
      $(".accordion_tab .blinking-icons-wrapper .heading-accodion").removeClass("active");
      $(this).addClass("active");
      $(".accordion_tab .blinking-icons-wrapper .main-accordion .content-accodion").slideUp(500);
      $(this).siblings(".accordion_tab .blinking-icons-wrapper .content-accodion").slideDown(500);
    }
  });
  // ------------------shipping return policy -------------
   $('footer.footer a.shipping.returns, .main-tab-data .description-section .shipping-popup-open').on('click', function(e) {
     e.preventDefault();
     $('body').addClass('shipping-return-popup');
     $('.shipping-popup.shipping-return-policy.shipping-return-policy').addClass('shipping-return-active');
     $('.shipping-popup.shipping-return-policy.shipping-return-active .close-icon').on('click', function() {
       $('body').removeClass('shipping-return-popup');
       $('.shipping-popup.shipping-return-policy').removeClass('shipping-return-active');
     });
   });
  $(".shipping-popup.shipping-return-policy .heading-accodion").on("click", function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".shipping-popup.shipping-return-policy.shipping-return-active .content-accodion").slideUp(500);
      } else {
        $(".shipping-popup.shipping-return-policy.shipping-return-active .heading-accodion").removeClass("active");
        $(this).addClass("active");
        $(".shipping-popup.shipping-return-policy.shipping-return-active .main-accordion .content-accodion").slideUp(500);
        $(this).siblings(".shipping-popup.shipping-return-policy.shipping-return-active .content-accodion").slideDown(500);
      }
    });
  // -------------------------faq's popup-------------------
   $('footer.footer a.faqs.link').on('click', function(e) {
     e.preventDefault();
     $('body').addClass('faq-wrapper-popup');
     $('.wrapper-faq-popup').addClass('faq-wrapper-active');
     $('.wrapper-faq-popup.faq-wrapper-active .close-icon').on('click', function() {
       $('body').removeClass('faq-wrapper-popup');
       $('.wrapper-faq-popup').removeClass('faq-wrapper-active');
     });
   });
  $(".wrapper-faq-popup .heading-accodion").on("click", function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".wrapper-faq-popup.faq-wrapper-active .content-accodion").slideUp(500);
      } else {
        $(".wrapper-faq-popup.faq-wrapper-active .heading-accodion").removeClass("active");
        $(this).addClass("active");
        $(".wrapper-faq-popup.faq-wrapper-active .main-accordion .content-accodion").slideUp(500);
        $(this).siblings(".wrapper-faq-popup.faq-wrapper-active .content-accodion").slideDown(500);
      }
  });
// --------------store locator faq slider---------------------
   $(".store-locator .accordion-tabs.store-locator .heading-accodion").on("click", function() {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).siblings(".store-locator .accordion-tabs.store-locator .content-accodion").slideUp(500);
      } else {
        $(".store-locator .accordion-tabs.store-locator .heading-accodion").removeClass("active");
        $(this).addClass("active");
        $(".store-locator .accordion-tabs.store-locator .main-accordion .content-accodion").slideUp(500);
        $(this).siblings(".store-locator .accordion-tabs.store-locator .content-accodion").slideDown(500);
      }
    });
  // -------------pdp slider ------------
$('.cstm_img_new .desktop-btn-scroll').click(function() {
    $(".product .cstm_img_new .nav-dots li.is-active").next().trigger('click');
});
// -------------pdp popup zoom -----------------
$(document).ready(function(){
    // Initialize Fancybox
    $('[data-fancybox="gallery"]').fancybox({
      loop: false,
      buttons: ["close"],
      animationEffect: "zoom",
      transitionEffect: "fade",
    });

    // Initialize Slick Slider

  });
  // -------------end mobile--------


// -------------pdp slider------------
$(".custom_cart_section .product-form_cart").click(function(){
  $('.sticky-bottom-price .quantity__input').val('1');
  $( ".product__info-container .product-form__submit.button.button--full-width.button--secondary" ).trigger( "click" );
 var pdp_update_price = $('.display_none_varients .variants-data.active').attr("main_price");
   $('.productPriceContainer .symbol-amount').text(pdp_update_price);
});
  $(".sticky-bottom-price .price-per-item__container .quantity__button[name='plus']").click(function(){
    $( ".product__info-container .price-per-item__container button.quantity__button[name='plus']" ).trigger( "click" );    
  });
  $(".sticky-bottom-price .price-per-item__container .quantity__button[name='minus']").click(function(){
    $( ".product__info-container .price-per-item__container button.quantity__button[name='minus']" ).trigger( "click" ); 
  });
  // -------------on load symbol  -------------
  var logo_text = $('.no-js-hidden.pdp_price_wrapper').attr('pdp_logo');
  var symbol = logo_text;
  $('.custom_price.productPriceContainer.inc-quantity .symbol-logo').text(symbol);
  $(".sticky-bottom-price .price-per-item__container .quantity__button").click(function(){
    var text = $('.display_none_varients .variants-data.active').attr("main_price");
    var str1 = text;
    var str2 = ",";
    if(str1.indexOf(str2) != -1){
      var text_2 = text.replace(',', '');
    }
    else{var text_2 = text;}
    var pdp_price = parseFloat(text_2);
    var data_input = $('.sticky-bottom-price input.quantity__input').val();
    var data_type = parseFloat(data_input);
    var total_price_update=((pdp_price*data_type).toFixed(2));
    $('.productPriceContainer .symbol-amount').text(total_price_update);
  });
  
   // -------------------product select pdp -------------
  $("#cars li.input-var-color").click(function (event) {
    var data = $(this).attr('variant_name');
    $('.main-pdp-varients .radio-input.'+data).trigger('click');
   //   $('ul#cars li.input-var-color' ).removeClass('color-active');
   // $('ul#cars li.input-var-color[variant_name='+data+']' ).addClass('color-active');
 var imge_url =$('li.input-var-color.color-active').attr('data-img');
  $('.product_main_imagess .image_pdp_img').each(function (index) {
    var img_each_url = $(this).attr('data_url');
    if(img_each_url == imge_url){
      var data_tag_num = $(this).attr('aria-describedby');
        $('.product .cstm_img_new ul.slick-dots li #'+data_tag_num).trigger('click');
    }
  })
  });
  $(".sticky-bottom-price .sticky-bottom-inner .varaint-pdp-slide").click(function () {
     $(this).toggleClass('active');
  });
  $(".sticky-bottom-price .sticky-bottom-inner .varaint-pdp-slide li.input-var-color").click(function () {   
    var value_name = $(this).attr('variant_title');
    var value_color = $(this).attr('bg-color');
    $('.sticky-bottom-price .sticky-bottom-inner .varaint-pdp-slide .main-wrap-colors .color-name').css('background-image', 'url(' + value_color + ')');
    $('.sticky-bottom-price .sticky-bottom-inner .varaint-pdp-slide .main-wrap-colors .title-varient-name').text(value_name);
  });
  // --------onload data---------

  // ---------sticky varieant -------------
   $(".sticky-bottom-price .sticky-bottom-inner .size-varient").click(function () {
     $(this).toggleClass('active-size');
  });
   $(".sticky-bottom-price .sticky-bottom-inner ul#size-variant .input-var-size .list-title").click(function () {   
   
     var data2 = $(this).attr('main_value_name');
    $('.main-pdp-varients .radio-input.'+data2).trigger('click');
 });
  
// ------------product color variant onload --------

var title_main = $('.product .main-pdp-varients .swatch-btns input:checked+label').attr('title_main');
  $('.size-varient .size-wrap-title .size-wrap-inner').text(title_main);

  
var active_varient_id = $('input.product-variant-id').attr('value');
  $('.display_none_varients .variants-data[variant_id='+active_varient_id +']' ).addClass('active');
  
 var color_title = $('.main-wrapper-outer .toggle-with-media.variant-title').attr('value_name');
var bg_var_color = $('.main-wrapper-outer .toggle-with-media.variant-title').attr('value_bg_url');
   $('.varaint-pdp-slide .main-wrap-colors .color-name').css('background-image', 'url(' + bg_var_color + ')');
  $('.varaint-pdp-slide .main-wrap-colors .title-varient-name').text(color_title);

  var color_main_title = $('.main-wrapper-outer .toggle-with-media.variant-title').attr('value_name');
$('.line-item-property__field input#rad-slaves1').attr('value', color_main_title);
  // ------end ----------
  
var v_title = $('.product .main-pdp-varients .swatch-btns input:checked').attr('value_name');
// var variant_title= $('ul#cars li.input-var-color[variant_name='+v_title+']').attr('variant_title');
// var bg_color = $('ul#cars li.input-var-color[variant_name='+v_title+']').attr('bg-color');

// $('ul#cars li.input-var-color' ).removeClass('color-active');
//   $('ul#cars li.input-var-color[variant_name='+v_title+']' ).addClass('color-active');
  var imge_url =$('li.input-var-color.color-active').attr('data-img');
  $('.product_main_imagess .image_pdp_img').each(function (index) {
    var img_each_url = $(this).attr('data_url');
    if(img_each_url == imge_url){
      var data_tag_num = $(this).attr('aria-describedby')
      $('.product .cstm_img_new ul.slick-dots li #'+data_tag_num).trigger('click');
    }
  })
  $('.footer__content-top.container a.product.care.link.link--text.list-menu__item.list-menu__item--link').click(function(e) {
    e.preventDefault();
    window.location.href= "https://honeylux.co/pages/about-us#ProductCare";
  });
  $('.cstm-featured-coll-slide .tab-products').slick({
      infinite: true,
      nextArrow:'<button class="prev_arrow"><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 6H20" stroke="black" stroke-miterlimit="10"/><path d="M15 11L20 6L15 1" stroke="black" stroke-miterlimit="10"/></svg></button>',
      prevArrow:'<button class="next_arrow"><svg width="21" height="12" viewBox="0 0 21 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21 6H1" stroke="black" stroke-miterlimit="10"/><path d="M6 11L1 6L6 1" stroke="black" stroke-miterlimit="10"/></svg></button>',
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows:true,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }

    ]
  });  
  // ------end document bracket---------
});
function myFunctionpopup(d) {

  setTimeout(function() {
    var pdp_id = d.getAttribute("main_value_name");
    var title_main_inner = d.getAttribute('title_main');
    // $('ul#cars li.input-var-color[variant_name='+pdp_id +']' ).trigger('click');
    // $('ul#cars li.input-var-color' ).removeClass('color-active');
    // $('ul#cars li.input-var-color[variant_name='+pdp_id +']' ).addClass('color-active');
    $(".sticky-bottom-price .varaint-pdp-slide.active").removeClass('active');
    var imge_url =$('li.input-var-color.color-active').attr('data-img');
    $('.product_main_imagess .image_pdp_img').each(function (index) {
    var img_each_url = $(this).attr('data_url');
    if(img_each_url == imge_url){
      var data_tag_num = $(this).attr('aria-describedby')
      $('.product .cstm_img_new ul.slick-dots li #'+data_tag_num).trigger('click');
    }
    });
     $('.display_none_varients .variants-data').removeClass('active');
     $('.display_none_varients .variants-data[main-title='+pdp_id+']').addClass('active');
 var price_update = $('.display_none_varients .variants-data[main-title='+pdp_id+']' ).attr('price');
    var price_update_total = $('.display_none_varients .variants-data[main-title='+pdp_id+']' ).attr('main_price');
    $('.sticky-bottom-price .sticky-bottom-inner .price .price-item').text(price_update);
    
    $('.sticky-bottom-price .sticky-bottom-inner .size-varient .size-wrap-inner').text(title_main_inner);
    
$('.price-per-item__container .quantity__input').val('1');
   $('.sticky-slider-pdp .symbol-amount').text(price_update_total);
  },1000);
}

function mycolor(c){
  setTimeout(function() {
    $('.input-var-color').on('click', function() {
    var wpurl = $(this).attr("data-url");
    $(this).parent().siblings(".pdp-main-url").attr('href', wpurl);
    $(this).parent().parent().siblings(".pdp-main-url").attr('href', wpurl);
    var wprice = $(this).attr("data-price");
    $(this).parent().siblings(".pdp-main-title").find('.price-pdp').text(wprice);
    var wsrc = $(this).attr("data-img");
    $(this).parent().parent().siblings(".pdp-main-url").find('.img-pdp-wrapper').attr('src', wsrc);
    var varient_id = $(this).attr("varient-id");
    $(this).parent().siblings("div").find('.product-variant-id').attr('value',varient_id);
  });
  },1000)
}

if (window.location.href == 'https://honeylux.co/pages/wholesale'){
 $('.button-slik.button-2').click(function(e) {
     e.preventDefault()
  $('html, body').animate({
    scrollTop: $(".shopify-section.custom-image-with-contact").offset().top
  }, 1000)
});
}
  function scrollPage() {
    window.scrollBy(0, 50); // Scroll down by 50 pixels
  }
function movecursor(){
  
}
$(document).ready(function() {
//   var scrollContainer  =  document.getElementsByClassName('img-wrap-scrollbar')[0];
//  // $('.img-wrap-scrollbar')[0];
// const content = document.querySelector('.product_main_imagess');
    
//     let isScrollingInsideDiv = false;

//     // Detect mouse movement to trigger scroll inside the div
//     scrollContainer.addEventListener('wheel', (event) => {
//         if (!isScrollingInsideDiv) {
//             isScrollingInsideDiv = true;
//             scrollInsideDiv(event);
//         }
//     });

//     // Smooth scroll inside the div
//     function scrollInsideDiv(event) {
//         const scrollHeight = content.scrollHeight - scrollContainer.clientHeight; // Total scrollable height of content
//         const scrollPosition = scrollContainer.scrollTop; // Current scroll position of the div
//         const scrollSpeed = 1; // Scroll speed

//         let moveDistance = (event.clientY / window.innerHeight) * scrollHeight - scrollPosition;

//         // GSAP scroll animation inside the div
//         gsap.to(scrollContainer, {
//             scrollTop: scrollPosition + moveDistance * scrollSpeed,
//             duration: 0.1,
//             ease: 'power1.out'
//         });

//         // If the div content ends, switch to page scrolling
//         if (scrollPosition + scrollContainer.clientHeight >= scrollHeight) {
//             switchToPageScroll(event);
//         }
        
//         // Stop scrolling after the mouse stops moving
//         setTimeout(() => {
//             isScrollingInsideDiv = false;
//         }, 100);
//     }

//     // Scroll the page once the div content reaches its end
//     function switchToPageScroll(event) {
//         // Page scroll speed (you can adjust this value)
//         const scrollSpeed = 10;

//         if (event.movementY > 0) {
//             window.scrollBy(0, scrollSpeed); // Scroll down the page
//         } else if (event.movementY < 0) {
//             window.scrollBy(0, -scrollSpeed); // Scroll up the page
//         }
//     }
var $scrollContainer = $('.product_main_imagess');
        // Listen for the scroll event
        $scrollContainer.addEventListener('wheel', function(event) {
          const isScrolledToBottom = $scrollContainer.scrollHeight - $scrollContainer.scrollTop === $scrollContainer.clientHeight;
    const isScrolledToTop = $scrollContainer.scrollTop === 0;
    if (isScrolledToBottom && event.deltaY > 0) {
      window.scrollBy(0, 50); 
      event.stopPropagation(); // Stop the event from bubbling up
       return;
    }

    // If the div is scrolled to the top, allow the page to scroll
    if (isScrolledToTop && event.deltaY < 0) {
      window.scrollBy(0, 50); 
      event.stopPropagation(); // Stop the event from bubbling up
       //return;
    }
        });
   
  });



